function isBackgroundDark(backgroundColor) {
  return (
    (backgroundColor.includes('base') && !backgroundColor.includes('background')) ||
    backgroundColor.includes('dark') ||
    backgroundColor.includes('shade') ||
    backgroundColor.includes('tone')
  )
}

export default isBackgroundDark
